export default "/assets/site/images/1.png?caf5143fefe8b1e23244c2be246c8a17";